"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductSpecsItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productSpecsFullImage = _interopRequireDefault(require("./product-specs-full-image"));
var _productSpecsFeaturesContainer = _interopRequireDefault(require("./product-specs-features-container"));
var _productSpecsMultiColumnContainer = _interopRequireDefault(require("./product-specs-multi-column-container"));
/**
 * Local Imports
 */

/**
 * ProductSpecsItem Component - handles rendering different layout types
 *
 * @param {Object} props React props
 * @param {String} props.layout Layout type ('features', 'fullImage', 'multiColumn')
 * @param {Object} props.tableProps Features Table Props
 * @param {Object} props.imageProps Full Image Props
 * @param {Object} props.multiColumnProps MultiColumn layout Props
 * @returns {React.ReactElement|null} Rendered layout component
 * @public
 */
function ProductSpecsItem({
  layout,
  tableProps,
  imageProps,
  multiColumnProps
}) {
  const renderComponentOrProps = (componentOrProps, Component) => /*#__PURE__*/_react.default.isValidElement(componentOrProps) ? componentOrProps : /*#__PURE__*/_react.default.createElement(Component, componentOrProps);
  const layoutComponentMap = {
    features: () => renderComponentOrProps(tableProps, _productSpecsFeaturesContainer.default),
    fullImage: () => renderComponentOrProps(imageProps, _productSpecsFullImage.default),
    multiColumn: () => renderComponentOrProps(multiColumnProps, _productSpecsMultiColumnContainer.default)
  };
  return layoutComponentMap[layout]?.() || null;
}
ProductSpecsItem.propTypes = {
  layout: _propTypes.default.oneOf(['features', 'fullImage', 'multiColumn']),
  tableProps: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object]),
  imageProps: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object]),
  multiColumnProps: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object])
};